// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles for Dog Score application */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Add smooth scrolling to the entire page */
html {
  scroll-behavior: smooth;
}

/* Reset box-sizing */
*, *::before, *::after {
  box-sizing: border-box;
}

/* Remove underline from all links */
a {
  text-decoration: none;
  color: inherit;
}

/* Hide the focus outline for mouse users, but keep for keyboard users */
:focus:not(:focus-visible) {
  outline: none;
}

/* Add focus outline for keyboard users */
:focus-visible {
  outline: 2px solid #2E7D32;
  outline-offset: 2px;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #2E7D32;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1B5E20;
}

/* Transitions for all hover effects */
a, button {
  transition: all 0.2s ease-in-out;
}

/* Prevent image overflow */
img {
  max-width: 100%;
  height: auto;
} `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA,4CAA4C;AAC5C;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":["/* Global styles for Dog Score application */\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* Add smooth scrolling to the entire page */\r\nhtml {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n/* Reset box-sizing */\r\n*, *::before, *::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Remove underline from all links */\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n/* Hide the focus outline for mouse users, but keep for keyboard users */\r\n:focus:not(:focus-visible) {\r\n  outline: none;\r\n}\r\n\r\n/* Add focus outline for keyboard users */\r\n:focus-visible {\r\n  outline: 2px solid #2E7D32;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Custom scrollbar */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #2E7D32;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #1B5E20;\r\n}\r\n\r\n/* Transitions for all hover effects */\r\na, button {\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n/* Prevent image overflow */\r\nimg {\r\n  max-width: 100%;\r\n  height: auto;\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
